import {useCallback, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {useUploadedFilesStore} from 'presentation/components/UploadFiles/store/useUploadedFilesStore';
import {AuthorizationsEnum, FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {getUserInfoFromToken} from 'presentation/utils';
import {useLocationStore} from '../../store/locationStore';
import {FlowType} from '../../store/locationStore/constants';
import {useAuthorizationsStore} from '../store/authorizationsStore';

export function useRequestAuthorization() {
	const navigate = useNavigate();
	const [exitFlowModalState, setExitFlowModalState] = useState(false);
	const [errorState, setErrorState] = useState(false);
	const resetUploadedFilesState = useUploadedFilesStore(state => state.resetUploadedFiles);
	const {resetProvidersList} = useAuthorizationsStore();

	const cdPessoaC = getUserInfoFromToken().cdPessoa;
	const getLocation = useLocationStore(state => state.getLocation);
	const selectedLocation = getLocation(cdPessoaC, FlowType.AUTHORIZATION);
	const {cdUf: cdUfSelected} = selectedLocation.state;
	const nmCidadeSelected = selectedLocation.city;

	const {isEnabled: isAutomationFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_AUTOMACAO_AUTOSOL,
	);

	const handleBack = () => {
		handleOpenExitModal();
	};

	const handleConfirmExitFlow = useCallback(() => {
		resetUploadedFilesState();
		if (isAutomationFlagEnabled) resetProvidersList();

		navigate(AuthorizationsEnum.AUTHORIZATIONS);
	}, []);

	const handleOpenExitModal = useCallback(() => {
		setExitFlowModalState(true);
	}, []);

	const handleCloseModalError = (isRedirect: boolean) => {
		setErrorState(false);
		if (isRedirect) {
			resetUploadedFilesState();
			setTimeout(() => {
				navigate(HomeEnum.HOME_PAGE);
			}, 200);
		}
	};

	return {
		handleBack,
		handleOpenExitModal,
		handleConfirmExitFlow,
		exitFlowModalState,
		setExitFlowModalState,
		errorState,
		setErrorState,
		handleCloseModalError,
		cdUfSelected,
		nmCidadeSelected,
	};
}
